import { Component } from '@angular/core';
import { SettingsOption } from 'src/app/enums/settings';
import { PermissionsService } from 'src/app/services/permissions.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent {
    readonly SettingsOption = SettingsOption;
    selectedComponent!: SettingsOption;
    env = environment;

    componentMapping: Record<SettingsOption, string> = {
        [SettingsOption.CERERE_PRIORITY]: 'app-cerere-priority',
        [SettingsOption.STATUS]: 'app-status',
        [SettingsOption.REQUEST_TYPES]: 'app-request-types',
        // [SettingsOption.CERERE_SABLOANE]: 'app-cerere-sabloane',
        [SettingsOption.UAT]: 'app-uat',
        [SettingsOption.OPERATORI]: 'app-operatori',
        [SettingsOption.DIRECTIE_COMPARTIMENTE]: 'app-directie-compartimente',
    };
    componentKeys: string[] = Object.keys(this.componentMapping);

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;

    constructor(public permissionsService: PermissionsService) {
        this.filterComponents();
    }

    filterComponents() {
        if (!this.permissionsService.hasPermission('dgitl-module.settings.prioritati-cerere.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.CERERE_PRIORITY
            );
        }

        if (!this.permissionsService.hasPermission('dgitl-module.settings.status-cerere.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.STATUS
            );
        }

        if (!this.permissionsService.hasPermission('dgitl-module.settings.tip-cerere.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.REQUEST_TYPES
            );
        }

        if (!this.permissionsService.hasPermission('dgitl-module.settings.unitati-administrativ-teritoriale.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.UAT
            );
        }

        if (!this.permissionsService.hasPermission('dgitl-module.settings.operatori.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.OPERATORI
            );
        }

        if (!this.permissionsService.hasPermission('dgitl-module.settings.directie-compartimente.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.DIRECTIE_COMPARTIMENTE
            );
        }
    }
}
